module.exports = __webpack_public_path__ + "img/logo.601d931a.png";